import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPinToLeftFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.9828 9.2399C21.9378 10.1952 21.4793 11.7288 20.3498 12.2008C18.8334 12.8346 17.393 13.9748 16.5419 14.976C15.684 15.9852 14.6814 17.6021 14.0927 19.2358C13.6623 20.4302 12.1037 20.8641 11.1571 19.9172L8.19794 16.9571L3.77992 21.3765C3.48712 21.6694 3.0124 21.6694 2.7196 21.3765C2.4268 21.0836 2.4268 20.6087 2.7196 20.3158L7.13761 15.8964L4.08832 12.8461C3.14177 11.8993 3.57546 10.3402 4.76952 9.90964C6.40273 9.32079 8.0191 8.31782 9.02792 7.45971C10.0288 6.60832 11.1687 5.16741 11.8023 3.65052C12.2741 2.52073 13.8073 2.06208 14.7622 3.01736L20.9828 9.2399Z",
		fill: "currentColor"
	})
});
export { SvgIconPinToLeftFilled as ReactComponent };
